import { render } from "./ToolDescriptionContent.vue?vue&type=template&id=0166f6f6"
import script from "./ToolDescriptionContent.vue?vue&type=script&lang=js"
export * from "./ToolDescriptionContent.vue?vue&type=script&lang=js"

import "./ToolDescriptionContent.vue?vue&type=style&index=0&id=0166f6f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__